module.exports = __webpack_public_path__ + "img/prize.4e0a7484.png";